<template>
  <div class="home">
    <!-- <van-nav-bar class="my-nav-bar" >
      <template #title>
        <span class="my-title">证书查询系统</span>
      </template>
      </van-nav-bar> -->

    <div class="title-banner">
      <img alt="" src="../assets/home/title.png" class="title-bg" />
    </div>
    <div :class="isPortrait ? 'buttons-v' : 'buttons-h'">
      <van-button type="default" block round @click="goToSearch('1')">
        园区AIGC培训证信息查询
      </van-button>
      <van-button type="default" block round @click="goToSearch('2')">
        职业资格证查询
      </van-button>
      <van-button type="default" block round @click="$router.push('/teachers')">
        园区师资查询
      </van-button>
      <!-- <van-button type="info" block round @click="goToEvaluation">
        教师评价
      </van-button> -->
      <!-- <van-button type="warning" block round @click="$router.push('/preview')">
        证书预览
      </van-button> -->
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "HomePage",
  data() {
    return {
      isPortrait: true, // 默认认为是竖屏
    };
  },
  mounted() {
    // 页面加载时检查一次方向
    this.checkOrientation();
    // 监听resize事件，在设备旋转时触发
    window.addEventListener("resize", this.checkOrientation);
  },
  beforeDestroy() {
    // 清除resize事件监听器以防止内存泄漏
    window.removeEventListener("resize", this.checkOrientation);
  },
  methods: {
    goToSearch(queryType) {
      // 证书类型：1=aigc，2=职业资格证
      this.$router.push({ path: "/certificate", query: { type: queryType } });
    },

    goToEvaluation() {
      const id = Math.floor(Math.random() * 14) + 1;
      this.$router.push(`/evaluation/${id}`);
    },

    checkOrientation() {
      if (window.innerHeight > window.innerWidth) {
        this.isPortrait = true;
        const aspectRatio = window.innerHeight / window.innerWidth;
        console.log(
          `当前屏幕方向为竖屏，宽高比为: ${aspectRatio.toFixed(2)}`
        );
      } else {
        this.isPortrait = false;
      }
    },
  },
};
</script>
  
  <style scoped>
.home {
  text-align: center;
  padding: 20px;
  margin-bottom: 20px;
  background-image: url("../assets/home/bg2.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: repeat;
  min-height: calc(100vh - 62px);
  /* position: absolute; */
}
.buttons-v {
  position: absolute;
  bottom: 15%;
  width: calc(100% - 40px);
  margin-bottom: 2.5rem;
}

.buttons-h {
  margin-bottom: 2.5rem;
}

.van-button {
  margin-bottom: 20px;
  width: 100%;
}

.my-nav-bar {
  background-color: transparent;
}

.my-title{
  font-size: 18px;
  font-weight: bold;
}

/* ::v-deep .van-nav-bar__title {
  color: #fff;
} */

.title-banner {
  width: 100%;
  /* margin: 4rem auto ; */
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.title-bg {
  width: 100%;
  height: auto;
}
</style>
  